import { Gift, Sparkles, Heart, ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";

const PACKAGES = [
  {
    icon: Gift,
    title: "Studio Gift Card",
    price: "Any amount",
    desc: "A thoughtful pause for someone you love. Redeemable on any current service.",
    accent: "bg-[#EAD584]",
  },
  {
    icon: Sparkles,
    title: "Massage Trio",
    price: "$240",
    desc: "Three 60-minute massages — a true reset for chronic tension, gifted or kept for yourself.",
    accent: "bg-[#F4ECC9]",
  },
  {
    icon: Heart,
    title: "The Grand Ritual",
    price: "$145",
    desc: "Ninety unhurried minutes of custom facial — deep cleanse, extended massage, treatment mask. A luminous reset.",
    accent: "bg-[#F2EBD3]",
  },
];

export default function GiftCards() {
  return (
    <section
      id="gift-cards"
      data-testid="gift-cards-section"
      className="relative py-24 md:py-36 bg-[#FAF6E8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-12 md:mb-20 items-end">
          <div className="col-span-12 md:col-span-7">
            <Reveal className="overline mb-6">Gift cards &amp; packages</Reveal>
            <Reveal delay={1}>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-light bb-ink">
                Give the gift of <span className="italic text-[#C9A65A]">slowing down.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={2} className="col-span-12 md:col-span-5">
            <p className="bb-ink-soft max-w-md text-base sm:text-lg leading-relaxed font-light">
              The most generous gift is permission to rest. Cards and curated
              packages, hand-prepared and ready to share.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {PACKAGES.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal
                key={p.title}
                delay={i + 1}
                testId={`gift-card-${i + 1}`}
                className="group relative bg-[#FAF6E8] border border-[#D9CFA0] rounded-lg p-8 transition-all hover:-translate-y-1 hover:shadow-[0_24px_60px_-30px_rgba(44,53,50,0.25)]"
              >
                <div className={`w-14 h-14 rounded-full ${p.accent} flex items-center justify-center mb-8`}>
                  <Icon className="w-6 h-6 bb-ink" />
                </div>
                <div className="overline mb-3">{p.price}</div>
                <h3 className="font-serif text-3xl bb-ink mb-3 font-light">{p.title}</h3>
                <p className="bb-ink-soft text-sm leading-relaxed font-light mb-8">{p.desc}</p>
                <a
                  href={`mailto:Bella@triplebtherapy.com?subject=${encodeURIComponent(`Gift inquiry — ${p.title}`)}`}
                  data-testid={`gift-card-cta-${i + 1}`}
                  className="inline-flex items-center gap-2 text-sm tracking-wider uppercase bb-ink link-underline"
                >
                  Inquire <ArrowUpRight className="w-4 h-4" />
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
